module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Shield-disabled-b96504a19bfc6b235b17c4e82f34f4c5.svg";